import { useState, forwardRef } from 'react'
import './BackupAdmin.css'
import Cookies from 'universal-cookie';
import {
    Button,
    CardContent,
    CardHeader,
    Divider,
    Grid,
     LinearProgress,
    Paper, Typography
} from '@material-ui/core';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import download from 'downloadjs';
import { useHistory } from 'react-router';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
export default function BackupAdmin() {
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const history = useHistory();
    const [fileChallenges, setFileChallenges] = useState('');
    const [uploadPercentageChallenges, setUploadPercentageChallenges] = useState(0);
    const [fileCTF, setFileCTF] = useState('');
    const [uploadPercentageCTF, setUploadPercentageCTF] = useState(0);
    const [fileLearning, setFileLearning] = useState('');
    const [uploadPercentageLearning, setUploadPercentageLearning] = useState(0);
    const [fileComplete, setFileComplete] = useState('');
    const [uploadPercentageComplete, setUploadPercentageComplete] = useState(0);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const onChangeHandlerChallenges = (event) => {
        setFileChallenges(event.target.files[0]);
        setUploadPercentageChallenges(0);
    }
    const onChangeHandlerCTF = (event) => {
        setFileCTF(event.target.files[0]);
        setUploadPercentageCTF(0)
    }
    const onChangeHandlerLearning = (event) => {
        setFileLearning(event.target.files[0]);
        setUploadPercentageLearning(0)
    }
    const onChangeHandlerComplete = (event) => {
        setFileComplete(event.target.files[0]);
        setUploadPercentageComplete(0)
    }
    const uploadFileChallenges = async e => {
        e.preventDefault();
        const formData = new FormData()
        formData.append('file', fileChallenges)
        try {
            await axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/backups/uploadFileChallenges`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': userToken
                },
                onUploadProgress: progressEvent => {
                    setUploadPercentageChallenges(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            }).then(response => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
            });
        } catch (err) {
            if (err.response.status === 500) {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            } else {
                setErrorMessage('Hubo un error en el servidor');
                setOpenError(true);
            }

        }
    }
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenError(false);
        setOpenSuccess(false);
    };
    const uploadFileCTF = async e => {
        e.preventDefault();
        const formData = new FormData()
        formData.append('file', fileCTF)
        try {
            await axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/backups/uploadFileCTF`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': userToken
                },
                onUploadProgress: progressEvent => {
                    setUploadPercentageCTF(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            }).then(response => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
            });
        } catch (err) {
            if (err.response.status === 500) {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            } else {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            }

        }
    }
    const uploadFileLearning = async e => {
        e.preventDefault();
        const formData = new FormData()
        formData.append('file', fileLearning)
        try {
            await axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/backups/uploadFileLearning`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': userToken
                },
                onUploadProgress: progressEvent => {
                    setUploadPercentageLearning(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            }).then(response => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
            });
        } catch (err) {
            if (err.response.status === 500) {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            } else {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            }

        }
    }
    const uploadFileComplete = async e => {
        e.preventDefault();
        const formData = new FormData()
        formData.append('file', fileComplete)
        try {
            await axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/backups/uploadFileComplete`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': userToken
                },
                onUploadProgress: progressEvent => {
                    setUploadPercentageComplete(
                        parseInt(
                            Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        )
                    );
                }
            }).then(response => {
                if (response.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else if (response.data.messageError) {
                    setErrorMessage(response.data.messageError);
                    setOpenError(true);
                }
            });
        } catch (err) {
            if (err.response.status === 500) {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            } else {
                setErrorMessage('Hubo un problema en el servidor');
                setOpenError(true);
            }

        }
    }
    const onBackupCTF = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupCTF`, {
          headers: {'Authorization':userToken}
        }).then(res=> {
	  if (res.data.noAuth) {

                cookies.remove('tokenCTF', { path: '/' });

                history.push('/login');

            }
          else if (res.data.messageDownload){ window.open(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupCTFFile`)}

	});
    }
    const onBackupChallenges = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupChallenges`,{
		headers:{'Authorization':userToken}
	}).then(res=> {
          if (res.data.noAuth) {

                cookies.remove('tokenCTF', { path: '/' });

                history.push('/login');

            }
          else if (res.data.messageDownload){ window.open(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupChallengesFile`)}


	}) 
    }
    const onBackupLearning = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupLearning`, {
		headers:{'Authorization': userToken}
	}).then(res=>{
            if (res.data.noAuth) {

                cookies.remove('tokenCTF', { path: '/' });

                history.push('/login');

            }

           else if (res.data.messageDownload){ window.open(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupAprendizajeFile`)}




		})
    }
    const onBackupCompleto = () => {
	axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupCompleto`, {
		headers:{'Authorization': userToken}
	}).then(res=>{
           if (res.data.noAuth) {

                cookies.remove('tokenCTF', { path: '/' });

                history.push('/login');

            }

          else if (res.data.messageDownload){ window.open(`https://${process.env.REACT_APP_BASE_URL}/api/backups/backupCompletoFile`)}

	})
    }
    const updateBackupChallenges = () => {
        if (uploadPercentageChallenges === 100) {
            axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/updateBackupChallenges`, {
                headers: { 'Authorization': userToken }
            }).then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)

                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                    }

                }
            });
        }
        else {
            setErrorMessage('Espere a que el archivo se suba al 100%')
            setOpenError(true)
        }
    }
    const updateBackupCTF = () => {
        if (uploadPercentageCTF === 100) {
            axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/updateBackupCTF`, {
                headers: { 'Authorization': userToken }
            }).then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)

                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                    }

                }
            });
        }
        else {
            setErrorMessage('Espere a que el archivo se suba al 100%')
            setOpenError(true)
        }
    }
    const updateBackupLearning = () => {
        if (uploadPercentageLearning === 100) {
            axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/updateBackupLearning`, {
                headers: { 'Authorization': userToken }
            }).then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)

                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                    }

                }
            });
        }
        else {
            setErrorMessage('Espere a que el archivo se suba al 100%')
            setOpenError(true)
        }
    }
    const updateBackupComplete = () => {
        if (uploadPercentageComplete === 100) {
            axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/updateBackupComplete`, {
                headers: { 'Authorization': userToken }
            }).then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)

                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                    }

                }
            });
        }
        else {
            setErrorMessage('Espere a que el archivo se suba al 100%')
            setOpenError(true)
        }
    }
    const downloadResultsCTF = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/getResultsCTF`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageError) {
                    setErrorMessage(res.data.messageError)
                    setOpenError(true)

                }
                else {
                    download(res.data,'resultadosCTF.xls')                    
                }

            }
        });

    }

    const resetCTF =() =>{
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/resetCTF`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setSuccessMessage(res.data.messageSuccess)
                    setOpenSuccess(true)

                }
                else {
                    setErrorMessage(res.data.messageError)
                    setOpenError(true)
                }

            }
        });
    }
    const downloadResultsLearning = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/getResultsLearning`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageError) {
                    setErrorMessage(res.data.messageError)
                    setOpenError(true)

                }
                else {
                    download(res.data,'resultadosAprendizaje.xls')                    
                }

            }
        });

    }
    const downloadResultsQuiz = () => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/backups/getResultsQuiz`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageError) {
                    setErrorMessage(res.data.messageError)
                    setOpenError(true)

                }
                else {
                    download(res.data,'resultadosCuestionarioAprendizaje.xls')                    
                }

            }
        });

    }
    return (

        <div className='backupAdmin'>
            <div className='pageContentTableBackup'>
                <Paper className="paddingBottom2">
                    <CardHeader
                        title="Respaldos de la plataforma"
                    />
                    <Divider />
                    <div className="marginTop2DisplayFlexWdith100">
                        <Button className="marginLeft5Color" variant="outlined" color="primary" onClick={(e) => { onBackupChallenges() }}>Retos</Button>
                        <Button className="marginLeft12Color" variant="outlined" color="primary" onClick={(e) => { onBackupCTF() }}>Competencia</Button>
                        <Button className="marginLeft12Color2" variant="outlined" color="primary" onClick={(e) => { onBackupLearning() }}>Aprendizaje</Button>
                        <Button className="marginLeft10" variant="outlined" color="secondary" onClick={(e) => { onBackupCompleto() }}>Todo</Button>
                    </div>
                </Paper>
                <br />
                <Paper>
                    <CardHeader
                        title="Restaurar desde respaldo (Al subir se reeemplaza la información existente)"
                    />
                    <Divider />
                    <Grid
                        container
                        spacing={4}
                        className="padding2"
                    >
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <label >
                                Archivo <br />
                            </label>
                            <input type="file" name="files" id='files' onChange={(e) => { onChangeHandlerChallenges(e) }}
                            />
                            <Button color="primary" variant="contained" className="buttonHeight30Margin2" onClick={uploadFileChallenges}>Subir</Button>
                            <div>
                                <LinearProgress variant="determinate" value={uploadPercentageChallenges}></LinearProgress>
                                <Typography variant="body2" color="text.secondary">{`${Math.round(
                                    uploadPercentageChallenges
                                )}%`}</Typography>
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}>
                            <br />
                            <Button className="buttonWidth100Color" variant="outlined" color="primary" onClick={updateBackupChallenges}>Actualizar retos</Button>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <label >
                                Archivo<br />
                            </label>
                            <input type="file" name="files" id='files' onChange={(e) => { onChangeHandlerCTF(e) }}
                            />
                            <Button color="primary" variant="contained" className="buttonHeight30Margin2Color2" onClick={uploadFileCTF}>Subir</Button>
                            <div>
                                <LinearProgress variant="determinate" value={uploadPercentageCTF}></LinearProgress>
                                <Typography variant="body2" color="text.secondary">{`${Math.round(
                                    uploadPercentageCTF
                                )}%`}</Typography>
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <br />
                            <Button className="buttonWidth100Color2" variant="outlined" color="primary" onClick={updateBackupCTF}>Actualizar competencia</Button>

                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <label >
                                Archivo <br />
                            </label>
                            <input type="file" name="files" id='files' onChange={(e) => { onChangeHandlerLearning(e) }}
                            />
                            <Button variant="contained" className="buttonHeight30Margin2Color3" onClick={uploadFileLearning}>Subir</Button>
                            <div>
                                <LinearProgress variant="determinate" value={uploadPercentageLearning} ></LinearProgress>
                                <Typography variant="body2" color="text.secondary">{`${Math.round(
                                    uploadPercentageLearning
                                )}%`}</Typography>
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={6}
                        >
                            <br />
                            <Button className="buttonWidth100Color3" variant="outlined" color="primary" onClick={updateBackupLearning}>Actualizar aprendizaje</Button>

                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <label >
                                Archivo  <br />
                            </label>
                            <input type="file" name="files" id='files' onChange={(e) => { onChangeHandlerComplete(e) }}
                            />
                            <Button variant="contained" color="secondary" className="buttonHeight30Margin2NoColor" onClick={uploadFileComplete}>Subir</Button>
                            <div>
                                <LinearProgress variant="determinate" value={uploadPercentageComplete}></LinearProgress>
                                <Typography variant="body2" color="text.secondary">{`${Math.round(
                                    uploadPercentageComplete
                                )}%`}</Typography>
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}>
                            <br />
                            <Button className="width100" variant="outlined" color="secondary" onClick={updateBackupComplete}>Actualizar Plataforma</Button>
                        </Grid>
                    </Grid>
                </Paper>
                <br />
                <Paper className="marginBottom5Top5">
                    <CardHeader
                        title="Reinicio y resultados de la competencia CTF"
                    />
                    <Divider />
                    <CardContent className="cardAlignCenter">
                        <Button className="buttonMarginRight2" variant="outlined" color="primary" onClick={downloadResultsCTF}>Descargar Resultados CTF</Button>
                        <Button variant="outlined" color="secondary" onClick={resetCTF}>Reiniciar CTF</Button>
                    </CardContent>
                </Paper>
                <Paper className="marginBottom5Top5">
                    <CardHeader
                        title="Aprendizaje"
                    />
                    <Divider />
                    <CardContent className="cardAlignCenter">
                        <Button className="buttonMarginRight2" variant="outlined" color="primary" onClick={downloadResultsLearning}>Descargar resultados de aprendizaje</Button>
                        <Button className="buttonMarginRight2" variant="outlined" color="primary" onClick={downloadResultsQuiz}>Descargar resultados de cuestionarios</Button>
                   
                    </CardContent>
                </Paper>

            </div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="width100Top0">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="width100Top0">
                    {success}
                </Alert>
            </Snackbar>
        </div>

    )
}

